import React from 'react';

import Features from 'components/Features';

const OrganizationsBenefits: React.FC = () => (
  <Features
    base="business.organizations.index.benefits.features"
    keys={['satisfaction-blue', 'increase', 'money']}
    imageSize={80}
  />
);

export default OrganizationsBenefits;
